import React, { Dispatch, SetStateAction } from 'react';
import * as _ from 'lodash';

export function useSessionStorageState<S>(storageKey: string, initialState: S): [S, Dispatch<SetStateAction<S>>] {
  return useStorageState(sessionStorage, storageKey, initialState);
}

export function useLocalStorageState<S>(storageKey: string, initialState: S): [S, Dispatch<SetStateAction<S>>] {
  return useStorageState(localStorage, storageKey, initialState);
}



function useStorageState<S>(storage: Storage, storageKey: string, initialState: S): [S, Dispatch<SetStateAction<S>>] {

  const [state, setState] = React.useState<S>(() => {
    let data: S | undefined | null;
    try {
      const jsonStr = storage.getItem(storageKey);
      if (jsonStr === 'undefined') {
        return initialState;
      } else if (jsonStr) {
        data = JSON.parse(jsonStr) as S
      }
    } catch (e) {
      console.error(e)
    }
    return typeof data !== 'undefined' && data !== null ? data : initialState;
  });

  const setStateWrapper = React.useCallback((value: SetStateAction<S>) => {
    const toSave = _.isFunction(value) ? value(state) : value
    try {
      storage.setItem(storageKey, JSON.stringify(toSave));
    } catch (e) {
      console.error(e)
    }
    setState(toSave)
  }, [setState, state]);

  return [state, setStateWrapper]
}
